<template>
  <div>
    <el-dialog :visible.sync="viewEditOrderDialogVisible" width="95%" :show-close="false" :close-on-click-modal="false">
      <span slot="title" class="font-weight-bold h4" v-if="currentOrderDetailsFirstItem">
        <div class="d-flex justify-content-between">
          <span>
            {{ isConfirmingOrder ? "Confirm Order" : "Edit Order" }}
            <el-tooltip
              :popper-class="currentOrderHasBeenCancelled ? 'isCancelled' : ''"
              class="item"
              effect="light"
              :content="currentOrderHasBeenCancelled ? 'this order has been cancelled' : 'This order has been edited'"
              placement="bottom"
            >
              <i
                v-if="currentOrderHasBeenEdited || currentOrderHasBeenCancelled"
                class="fa fa-exclamation-triangle mr-1"
                :class="[
                  { 'edited-order-icon-color': currentOrderHasBeenEdited && !currentOrderHasBeenCancelled },
                  { 'cancelled-order-icon-color': currentOrderHasBeenCancelled },
                ]"
                style="font-size: 20px"
              ></i>
            </el-tooltip>
          </span>
          <span>
            <i
              @click="hasChangeOccured ? showRemovalConfirmation(true) : $emit('update:viewEditOrderDialog', false)"
              class="fas fa-lg fa-times"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </span>
        </div>
      </span>
      <el-card>
        <el-form
          ref="liftingPeriodForm"
          :model="editOrderForm"
          label-width="120px"
          label-position="left"
          :rules="liftingPeriodRules"
          v-if="currentOrderDetailsFirstItem"
        >
          <el-row :gutter="20" v-if="currentOrderDetailsFirstItem" class="customLineHeight">
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span class="font-weight-bold"> Contract Number </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span>
                {{ currentOrderDetailsFirstItem.contractNumber ? currentOrderDetailsFirstItem.contractNumber : "-" }}
              </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span class="font-weight-bold"> Customer </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span>
                {{ currentOrderDetailsFirstItem.account }}
              </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="currentOrderDetailsFirstItem && !isContract">
              <span class="font-weight-bold"> Payment Terms </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="currentOrderDetailsFirstItem && !isContract">
              <span>
                {{ currentOrderDetailsFirstItem.credit_days }}
              </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span class="font-weight-bold"> Date </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span class="text-nowrap">
                {{ currentOrderDetailsFirstItem.date }}
              </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span class="font-weight-bold">
                {{ isBunkering ? "Network" : "Terminal" }}
              </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
              <span>
                {{ currentOrderDetailsFirstItem.terminal }}
              </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="isDeliveredIn">
              <span class="font-weight-bold"> Delivery Date </span>
            </el-col>
            <el-col
              :xs="12"
              :sm="6"
              :md="4"
              :lg="3"
              class="pt-1"
              v-if="isDeliveredIn && !isConfirmingOrder && !currentOrderHasBeenCancelled"
            >
              <el-form-item prop="deliveryDate" size="mini">
                <el-date-picker
                  class="w-100"
                  v-model="editOrderForm.deliveryDate"
                  :format="'dd/MM/yyyy'"
                  type="date"
                  :picker-options="deliveryDateOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col
              :xs="12"
              :sm="6"
              :md="4"
              :lg="3"
              v-if="isDeliveredIn && (isConfirmingOrder || currentOrderHasBeenCancelled)"
              class="pt-1"
            >
              {{ convertStringToDate(editOrderForm.deliveryDate) }}
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="isDeliveredIn">
              <span class="font-weight-bold"> Delivery Location </span>
            </el-col>
            <el-col
              :xs="12"
              :sm="6"
              :md="4"
              :lg="3"
              v-if="isDeliveredIn && !isConfirmingOrder && !currentOrderHasBeenCancelled"
              class="pt-1"
            >
              <el-form-item prop="selectedDeliveryLocation" size="mini">
                <el-select v-model="editOrderForm.deliveryLocation" value-key="_id" filterable>
                  <el-option
                    v-for="location in deliveryLocations"
                    :key="location._id"
                    :label="location.name"
                    :value="location"
                  >
                  </el-option>
                  <template #empty>No location found</template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="12"
              :sm="6"
              :md="4"
              :lg="3"
              v-if="isDeliveredIn && (isConfirmingOrder || currentOrderHasBeenCancelled)"
              class="pt-1"
            >
              {{ editOrderForm.deliveryLocation.name }}
            </el-col>
          </el-row>
          <el-row :gutter="24" class="pt-2 customLineHeight" :class="{ customFontSize: $breakpoint.lgAndUp }">
            <el-col
              :xs="12"
              :sm="6"
              :md="4"
              :lg="3"
              :class="!isConfirmingOrder && !currentOrderHasBeenCancelled ? 'pt-2' : 'pt-2'"
              v-if="!isBunkering"
            >
              <span class="font-weight-bold"> Lifting Period </span>
            </el-col>
            <el-col
              :xs="
                !((isConfirmingOrder || currentOrderHasBeenCancelled) && currentOrderDetailsFirstItem)
                  ? 16
                  : 12
              "
              :sm="18"
              :md="12"
              :lg="9"
              class="pt-2"
              v-if="!isBunkering"
            >
              <el-form-item
                prop="liftingPeriod"
                v-if="!isConfirmingOrder && !currentOrderHasBeenCancelled"
              >
                <el-date-picker
                  size="mini"
                  v-model="editOrderForm.liftingPeriod"
                  type="daterange"
                  range-separator="-"
                  :format="'dd/MM/yyyy'"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  :picker-options="pickerStartOptions"
                >
                </el-date-picker>
              </el-form-item>
              <span
                v-if="
                  (isConfirmingOrder || currentOrderHasBeenCancelled) && currentOrderDetailsFirstItem
                "
              >
                {{ convertStringToDate(editOrderForm.liftingPeriod[0]) }} -
                {{ convertStringToDate(editOrderForm.liftingPeriod[1]) }}
              </span>
            </el-col>
            <el-col
              :xs="
                !((isConfirmingOrder || currentOrderHasBeenCancelled) && currentOrderDetailsFirstItem)
                  ? 16
                  : 12
              "
              :sm="6"
              :md="4"
              :lg="3"
              v-if="hasMultipleRefs() === false"
              class="pt-2"
            >
              <span class="font-weight-bold"> Ref </span>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="3" v-if="hasMultipleRefs() === false" class="pt-2">
              <el-form-item
                v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                :prop="editOrderForm.reference"
                size="mini"
              >
                <el-input v-model="editOrderForm.reference"> </el-input>
              </el-form-item>
              <span v-else>
                {{ currentOrderDetailsFirstItem.reference ? currentOrderDetailsFirstItem.reference : "-" }}
              </span>
            </el-col>
          </el-row>
        </el-form>
        <el-row
          :gutter="24"
          v-if="currentOrderDetailsFirstItem && !isConfirmingOrder"
          class="pb-2 customLineHeight"
          :class="{ customFontSize: $breakpoint.lgAndUp }"
        >
          <el-col :xs="12" :sm="6" :md="4" :lg="3" class="mt-2 pt-1">
            <span class="font-weight-bold"> Status </span>
          </el-col>
          <el-col
            :xs="12"
            :sm="6"
            :md="6"
            :lg="4"
            class="pt-1 mt-2"
            :class="`text-${calculateOrderDisplay().textColor}`"
          >
            <span>
              {{ calculateOrderDisplay().text }}
            </span>
          </el-col>
          <el-col :xs="6" :sm="5" :md="4" :lg="4" class="pt-1">
            <el-button
              size="small"
              class="btn btn-destructive"
              @click="cancelOrder"
              v-if="!currentOrderHasBeenCancelled"
              >Cancel Order</el-button
            >
          </el-col>
          <el-col :xs="12" :sm="5" :md="4" :lg="4" class="pt-1"> </el-col>
        </el-row>
      </el-card>
      <el-form
        ref="form"
        :model="{ currentOrderDetails }"
        label-width="120px"
        label-position="left"
        v-if="currentOrderDetailsFirstItem"
      >
        <!-- Cards for smaller Screens -->
        <div v-if="currentOrderDetailsFirstItem && $breakpoint.mdAndDown" class="pb-2">
          <el-row
            v-if="isGenerateOrderNumbersEnabled && !isBunkering && isAtLeastOneSplitItem && !isPending"
            class="pb-3"
          >
            <el-col :span="3" class="mt-2 font-weight-bold text-t_blue">
              {{ selectedOffers.length }} {{ selectedOffers.length === 1 ? "item" : "items" }} Selected
            </el-col>
            <el-col :span="6">
              <el-button class="btn btn-actionable" @click="generateReleaseNumber" :disabled="!selectedOffers.length">
                {{ selectedOffers.length > 0 ? "Generate Release No." : "Select Orders to Generate Release Number" }}
              </el-button>
            </el-col>
          </el-row>
          <el-row
            v-if="
              !currentOrderHasBeenCancelled &&
              !isBunkering &&
              !isConfirmingOrder &&
              !isCancelingOrder &&
              !isAtLeastOneSplitItem
            "
            class="pb-3"
          >
            <el-col :span="3" class="mt-2 font-weight-bold text-t_blue">
              {{ selectedOffers.length }} {{ selectedOffers.length === 1 ? "item" : "items" }} Selected
            </el-col>
            <el-col :span="6">
              <el-button class="btn btn-destructive" @click="removeLineItems" :disabled="!selectedOffers.length">
                {{ selectedOffers.length > 0 ? "Remove Selected Orders" : "Select Orders to Remove" }}
              </el-button>
            </el-col>
          </el-row>
          <el-card class="py-1 mb-3" v-for="(order, index) in currentOrderDetails" :key="index">
            <el-row :gutter="20">
              <el-col
                :xs="24"
                :sm="24"
                class="pt-1"
                v-if="!isBunkering && order.isSplit && !isPending && isAtLeastOneSplitItem"
              >
                <input type="checkbox" v-if="order.isSplit" v-model="selectedOffers" :value="order.orderId" />
              </el-col>
              <el-col
                :xs="24"
                :sm="24"
                class="pt-1"
                v-if="
                  !currentOrderHasBeenCancelled &&
                  !isConfirmingOrder &&
                  !isCancelingOrder &&
                  !isAtLeastOneSplitItem
                "
              >
                <input
                  type="checkbox"
                  v-model="selectedOffers"
                  v-if="!order.lineItemCancelled"
                  :value="order.orderId"
                />
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering">
                <span class="font-weight-bold"> Product </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering">
                <span> {{ order.fuel }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                <span class="font-weight-bold"> Network </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                <span> {{ order.terminal }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="hasMultipleRefs()">
                <span class="font-weight-bold"> Ref </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="hasMultipleRefs()">
                <span> {{ getReferenceLineNumber(index) }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="manageOrderNumbersEnabled">
                <span class="font-weight-bold"> Order Id </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="manageOrderNumbersEnabled">
                <span> {{ !order.isSplit && order.orderId ? order.orderId : "-" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <span class="font-weight-bold"> Release No. </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <el-form-item
                  v-if="order.isSplit && !isPending"
                  :prop="'currentOrderDetails.' + index + '.releaseNumber'"
                  :rules="formRules.releaseNumber"
                  class="pt-3 pb-2"
                >
                  <el-input v-model="order.releaseNumber" :disabled="isGenerateOrderNumbersEnabled"> </el-input>
                </el-form-item>
                <span v-else> {{ order.releaseNumber ? order.releaseNumber : "-" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <span class="font-weight-bold"> Movement No. </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                <el-form-item
                  v-if="!isPending && !currentOrderHasBeenCancelled && !isConfirmingOrder"
                  :prop="'currentOrderDetails.' + index + '.movementNumber'"
                  class="pt-3 pb-2"
                >
                  <el-input :disabled="order.lineItemCancelled" v-model="order.movementNumber">
                  </el-input>
                </el-form-item>
                <span v-else> {{ order.movementNumber ? order.movementNumber : "-" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                <span class="font-weight-bold"> Account No. </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                <span> {{ order.bunkeringAccountNumber }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Bio Pricing </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span> {{ order.bioPrice }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Measurement </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span> {{ order.measurement }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isContract">
                <span class="font-weight-bold"> Payment Terms </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isContract">
                <span> {{ order.credit_days }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span class="font-weight-bold"> {{ isDeliveredIn ? "Ex-Rack Price ppl" : "Price ppl" }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <el-form-item
                  v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder && !(order.type_id === 'SETTLEMENT' && !order.settledAt)"
                  :prop="'currentOrderDetails.' + index + '.price'"
                  :rules="formRules.price"
                  class="pt-3 pb-2"
                >
                  <el-input
                    @input.native="onInputCleaveFormatValue(index, 'price')"
                    v-cleave="numeralPositive"
                    v-model="order.price"
                    :disabled="order.lineItemCancelled"
                  >
                  </el-input>
                </el-form-item>
                <span v-else-if="order.type_id === 'SETTLEMENT' && !order.settledAt">
                  Pending Settlement
                </span>
                <span v-else>
                  {{ order.price | priceformat }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span class="font-weight-bold"> Haulage ppl </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span> {{ order.haulage }} </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span class="font-weight-bold"> Delivered Price </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                <span>
                  {{ (stringToNumber(order.price) + stringToNumber(order.haulage)).toFixed(2) | priceformat }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Vol/L </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <el-form-item
                  v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                  :prop="'currentOrderDetails.' + index + '.quantity'"
                  :rules="formRules.quantity"
                  class="pt-3 pb-2"
                >
                  <el-input
                    @input.native="onInputCleaveFormatValue(index, 'quantity')"
                    v-cleave="naturalNumber"
                    v-model="order.quantity"
                    :disabled="order.lineItemCancelled"
                  >
                  </el-input>
                </el-form-item>
                <span v-else>
                  {{ order.quantity }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Total (£) </span> </el-col>
              <el-col :xs="12" :sm="12" class="pt-1">
                <span v-if="order.type_id === 'SETTLEMENT' && !order.settledAt">—</span>
                <span v-else-if="isDeliveredIn">
                  {{
                    (
                      ((stringToNumber(order.price) + stringToNumber(order.haulage)) * stringToNumber(order.quantity)) /
                      100
                    ).toFixed(2) | priceformat
                  }}
                </span>
                <span v-else>
                  {{ ((stringToNumber(order.price) * stringToNumber(order.quantity)) / 100).toFixed(2) | priceformat }}
                </span>
              </el-col>
            </el-row>
            <orderPriceBreakDown
              v-if="currentOrderDetailsFirstItem.pricingEngineEnabled && getOrderMarketWindow"
              :cards="true"
              :index="index"
              :order="order"
              :getOrderMarketWindow="getOrderMarketWindow"
              :productConfig="productConfig"
              :bioProductConfig="bioProductConfig"
              :isContract="isContract"
            />
            <el-col :xs="12" :sm="12" class="pt-1 d-flex">
              <div
                v-if="
                  !isBunkering &&
                  !currentOrderHasBeenCancelled &&
                  !isConfirmingOrder &&
                  !isCancelingOrder &&
                  !isItemSelected
                "
              >
                <el-button size="small" class="btn btn-actionable" v-if="!order.isSplit" @click="splitItem(order)">
                  Split Volume
                </el-button>
                <el-button size="small" class="btn btn-actionable" v-else @click="unsplitItem(order)"> Undo </el-button>
              </div>
            </el-col>
          </el-card>
        </div>
        <el-row
          v-if="isGenerateOrderNumbersEnabled && !isBunkering && isAtLeastOneSplitItem && !isPending"
          class="pb-3"
        >
          <el-col :span="3" class="mt-2 font-weight-bold text-t_blue">
            {{ selectedOffers.length }} {{ selectedOffers.length === 1 ? "item" : "items" }} Selected
          </el-col>
          <el-col :span="6">
            <el-button class="btn btn-actionable" @click="generateReleaseNumber" :disabled="!selectedOffers.length">
              {{ selectedOffers.length > 0 ? "Generate Release No." : "Select Orders to Generate Release Number" }}
            </el-button>
          </el-col>
        </el-row>
        <el-row
          v-if="
            !currentOrderHasBeenCancelled &&
            !isConfirmingOrder &&
            !isCancelingOrder &&
            !isAtLeastOneSplitItem
          "
          class="pb-3"
        >
          <el-col :span="3" class="mt-2 font-weight-bold text-t_blue">
            {{ selectedOffers.length }} {{ selectedOffers.length === 1 ? "item" : "items" }} Selected
          </el-col>
          <el-col :span="6">
            <el-button class="btn btn-destructive" @click="removeLineItems" :disabled="!selectedOffers.length">
              {{ selectedOffers.length > 0 ? "Remove Selected Orders" : "Select Orders to Remove" }}
            </el-button>
          </el-col>
        </el-row>
        <!-- Table for larger screens -->
        <el-row class="pt-3 pb-1" v-if="$breakpoint.lgAndUp">
          <el-col :span="24">
            <el-table
              ref="table"
              :data="currentOrderDetails"
              :fit="true"
              size="mini"
              :header-cell-class-name="tableHeaderClass"
            >
              <el-table-column
                width="55"
                v-if="isGenerateOrderNumbersEnabled && !isBunkering && !isPending && isAtLeastOneSplitItem"
              >
                <template slot-scope="scope">
                  <input type="checkbox" v-model="selectedOffers" :value="scope.$index" v-if="scope.row.isSplit" />
                </template>
              </el-table-column>
              <el-table-column
                width="55"
                v-if="
                  !currentOrderHasBeenCancelled &&
                  !isConfirmingOrder &&
                  !isCancelingOrder &&
                  !isAtLeastOneSplitItem
                "
              >
                <template slot-scope="scope">
                  <input
                    type="checkbox"
                    v-model="selectedOffers"
                    :value="scope.$index"
                    v-if="!scope.row.lineItemCancelled"
                  />
                </template>
              </el-table-column>
              <el-table-column align="left" label="Product" min-width="100px" v-if="!isBunkering">
                <template slot-scope="scope">
                  <span>{{ scope.row.fuel }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Network" min-width="100px" v-if="isBunkering">
                <template slot-scope="scope">
                  <span>{{ scope.row.terminal }}</span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Order Id" min-width="100px" v-if="manageOrderNumbersEnabled">
                <template slot-scope="scope">
                  <span> {{ !scope.row.isSplit && scope.row.orderId ? scope.row.orderId : "-" }} </span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="Release No."
                min-width="100px"
                v-if="!isBunkering && manageOrderNumbersEnabled"
              >
                <template slot-scope="scope">
                  <el-form-item
                    v-if="scope.row.isSplit && !isPending"
                    :prop="'currentOrderDetails.' + scope.$index + '.releaseNumber'"
                    :rules="formRules.releaseNumber"
                    class="pt-3 pb-2"
                  >
                    <el-input v-model="scope.row.releaseNumber" :disabled="isGenerateOrderNumbersEnabled"> </el-input>
                  </el-form-item>
                  <span v-else> {{ scope.row.releaseNumber ? scope.row.releaseNumber : "-" }} </span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="Movement No."
                min-width="100px"
                v-if="!isBunkering && manageOrderNumbersEnabled"
              >
                <template slot-scope="scope">
                  <el-form-item
                    v-if="!isPending && !currentOrderHasBeenCancelled && !isConfirmingOrder"
                    :prop="'currentOrderDetails.' + scope.$index + '.movementNumber'"
                    class="pt-3 pb-2"
                  >
                    <el-input :disabled="scope.row.lineItemCancelled" v-model="scope.row.movementNumber"> </el-input>
                  </el-form-item>
                  <span v-else> {{ scope.row.movementNumber ? scope.row.movementNumber : "-" }} </span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Ref" v-if="hasMultipleRefs()" min-width="120px">
                <template slot-scope="scope">
                  <span> {{ getReferenceLineNumber(scope.$index) }} </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Account No." v-if="isBunkering" min-width="100px">
                <template slot-scope="scope">
                  <span> {{ scope.row.bunkeringAccountNumber }} </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Bio Pricing" min-width="100px">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.bioPrice }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Measurement" min-width="100px">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.measurement }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Payment Terms" min-width="100px" v-if="isContract">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.credit_days }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                :label="isDeliveredIn ? 'Ex-Rack Price ppl' : 'Price ppl'"
                min-width="120px"
              >
                <template slot-scope="scope">
                  <el-form-item
                    v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder && !(scope.row.type_id === 'SETTLEMENT' && !scope.row.settledAt)"
                    :prop="'currentOrderDetails.' + scope.$index + '.price'"
                    :rules="formRules.price"
                    class="pt-3 pb-2"
                  >
                    <el-input
                      :disabled="scope.row.lineItemCancelled"
                      @input.native="onInputCleaveFormatValue(scope.$index, 'price')"
                      v-cleave="numeralPositive"
                      v-model="scope.row.price"
                    >
                    </el-input>
                  </el-form-item>
                  <span v-else-if="scope.row.type_id === 'SETTLEMENT' && !scope.row.settledAt"
                  class="">
                    Pending Settlement
                  </span>
                  <span v-else>
                    {{ scope.row.price | priceformat }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Haulage ppl" min-width="120px" v-if="isDeliveredIn">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.haulage }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Delivered Price" min-width="120px" v-if="isDeliveredIn">
                <template slot-scope="scope">
                  <span>
                    {{ (stringToNumber(scope.row.price) + stringToNumber(scope.row.haulage)) | priceformat }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="Vol/L" min-width="120px">
                <template slot-scope="scope">
                  <el-form-item
                    v-if="!currentOrderHasBeenCancelled && !isConfirmingOrder"
                    :prop="'currentOrderDetails.' + scope.$index + '.quantity'"
                    :rules="formRules.quantity"
                    class="pt-3 pb-2"
                  >
                    <el-input
                      :disabled="scope.row.lineItemCancelled"
                      @input.native="onInputCleaveFormatValue(scope.$index, 'quantity')"
                      v-cleave="naturalNumber"
                      v-model="scope.row.quantity"
                    >
                    </el-input>
                  </el-form-item>
                  <span v-else>
                    {{ scope.row.quantity }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Total GBP" min-width="130px">
                <template slot-scope="scope">
                  <span v-if="scope.row.type_id === 'SETTLEMENT' && !scope.row.settledAt">—</span>
                  <span v-else-if="isDeliveredIn">
                    {{
                      (
                        ((stringToNumber(scope.row.price) + stringToNumber(scope.row.haulage)) *
                          stringToNumber(scope.row.quantity)) /
                        100
                      ).toFixed(2) | priceformat
                    }}
                  </span>
                  <span v-else>
                    {{
                      ((stringToNumber(scope.row.price) * stringToNumber(scope.row.quantity)) / 100).toFixed(2)
                        | priceformat
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column min-width="50px" v-if="currentOrderDetailsFirstItem.pricingEngineEnabled">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="expandedRowIndex.includes(scope.$index) ? 'Hide Price Breakdown' : 'Show Price Breakdown'"
                    placement="top"
                  >
                    <i
                      class="mr-1 text-t_blue"
                      :class="expandedRowIndex.includes(scope.$index) ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                      style="font-size: 20px"
                      @click="toggleExpand(scope.row, scope.$index)"
                    >
                    </i>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="canSplitItems ? '120px' : '50px'"
                v-if="canSplitItems || (isAtLeastOneCancelledItem && !currentOrderHasBeenCancelled)"
              >
                <template slot-scope="scope">
                  <div v-if="!scope.row.lineItemCancelled && canSplitItems" class="d-flex">
                    <el-button
                      size="small"
                      class="btn btn-actionable"
                      v-if="!scope.row.isSplit"
                      @click="splitItem(scope.row)"
                    >
                      Split Volume
                    </el-button>
                    <el-button size="small" class="btn btn-actionable" v-else @click="unsplitItem(scope.row)">
                      Undo
                    </el-button>
                  </div>
                  <el-tooltip
                    class="pr-1"
                    content="This item has been removed from the order"
                    placement="top"
                    v-if="scope.row.lineItemCancelled"
                  >
                    <i class="fas fa-flag pr-1 text-t_red"> </i>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column type="expand" v-if="currentOrderDetailsFirstItem.pricingEngineEnabled" width="1px">
                <template slot-scope="scope">
                  <orderPriceBreakDown
                    v-if="currentOrderDetailsFirstItem.pricingEngineEnabled && getOrderMarketWindow"
                    :key="scope.$index"
                    :index="scope.$index"
                    :order="scope.row"
                    :getOrderMarketWindow="getOrderMarketWindow"
                    :productConfig="productConfig"
                    :bioProductConfig="bioProductConfig"
                    :isContract="isContract"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :xs="24" :md="12" class="pb-4 mt-2">
          <el-card>
            <label> Order Notes </label>
            <br />
            {{ currentOrderDetailsFirstItem && currentOrderDetailsFirstItem.orderNotes }}
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer-center">
        <el-row :gutter="20">
          <el-button
            size="small"
            class="btn btn-neutral"
            @click="hasChangeOccured ? showRemovalConfirmation(true) : $emit('update:viewEditOrderDialog', false)"
            >Close</el-button
          >
          <el-button
            size="small"
            class="btn"
            :class="hasChangeOccured || isConfirmingOrder ? 'btn-confirm' : 'btn-neutral'"
            @click="saveChanges"
            v-if="!currentOrderHasBeenCancelled"
            :disabled="!hasChangeOccured && !isConfirmingOrder"
          >
            {{
              manageOrderNumbersEnabled && isConfirmingOrder
                ? "Add Order Numbers"
                : !manageOrderNumbersEnabled && isConfirmingOrder
                ? "Confirm Order"
                : "Save Changes"
            }}
          </el-button>
        </el-row>
      </span>
    </el-dialog>
    <editDeleteOrderConfirmationDialog
      v-if="viewEditDeleteConfirmationDialog"
      :viewEditDeleteConfirmationDialog.sync="viewEditDeleteConfirmationDialog"
      :viewEditOrderDialogVisible.sync="viewEditOrderDialogVisible"
      :isCancelingOrder.sync="isCancelingOrder"
      :isConfirmingOrder.sync="isConfirmingOrder"
      :viewEditOrderDialog.sync="viewEditOrderDialog"
      @closeEditOrderDialog="closeEditOrderDialog"
      @refreshModal="reloadOffers"
      :orderToUpdate="orderUpdates"
      :orderId="currentOrderDetailsFirstItem._id"
      :isBunkering="isBunkering"
      :isComingFromOrderCapture="isComingFromOrderCapture"
      :isCancellingLineItem="isCancellingLineItem"
      :lineItemIndices="cancelledLineItemIndices"
    />
    <manageOrderNumbersDialog
      v-if="viewManageOrderNumbersDialog"
      :viewManageOrderNumbersDialog.sync="viewManageOrderNumbersDialog"
      :viewEditOrderDialogVisible.sync="viewEditOrderDialogVisible"
      @closeEditOrderDialog="closeEditOrderDialog"
      :orderToUpdate="currentOrderDetails"
      :orderId="currentOrderDetailsFirstItem._id"
      :isBunkering="isBunkering"
      :isComingFromOrderCapture="isComingFromOrderCapture"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import breakpoint from "@/mixins/index";
import orderPriceBreakDown from "../components/Tools/OrderPriceBreakDown.vue";
import { getOrderStatusDisplay } from "@/util/orderBuilder";
import { formatStringToNumber, formatDateAsDMY } from "@/util/util";
import { makeGenericContractFromContractFrequency } from "@/util/contracts";
import { getLocations } from "@/api/metadata";
import { getBasket } from "../api/basket.js";
import { getOffers } from "../api/offers.js";
import isEqual from "lodash/isEqual";
import moment from "moment";
import editDeleteOrderConfirmationDialog from "./EditDeleteOrderConfirmation.vue";
import manageOrderNumbersDialog from "./ManageOrderNumbersDialog.vue";

export default {
  components: {
    editDeleteOrderConfirmationDialog,
    manageOrderNumbersDialog,
    orderPriceBreakDown,
  },
  mixins: [breakpoint],
  props: {
    orders: {
      type: Array,
      required: true,
      default: () => [],
    },
    viewEditOrderDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    isConfirmingOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
    isComingFromOrderCapture: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const validateLiftingPeriod = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error(" "));
      }
      callback();
    };
    const validateNumberInput = (rule, value, callback) => {
      if (this.stringToNumber(value) <= 0) {
        callback(new Error("Please enter a value greater than 0"));
      } else {
        callback();
      }
    };
    const validateReleaseNumberInput = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Release Number is required"));
        return;
      } else {
        callback();
      }
    };
    const validateOfferInput = async (rule, value, callback) => {
      const index = Number(rule.field.split(".")[1]);
      if (!this.currentOrderDetails || this.currentOrderDetails.length === 0) {
        callback();
      }
      const result = await this.getOfferFromOrder(index);
      if (result && result.notFound) {
        callback(new Error("Failed to find offer in order to validate volume availability"));
      } else if (!result) {
        callback(new Error("Failed to retrieve offer to validate volume availability"));
      } else if (this.currentOfferFromOrder) {
        const { maximumAvailable, minimumOrderQuantity } = this.currentOfferFromOrder;
        const convertedValue = this.stringToNumber(value);
        const { quantity } = this.currentOrderDetails[index];
        if (
          convertedValue < minimumOrderQuantity ||
          convertedValue > maximumAvailable + this.stringToNumber(quantity)
        ) {
          callback(
            new Error(
              `Please enter a value between ${minimumOrderQuantity} and ${
                maximumAvailable + this.stringToNumber(quantity)
              }`
            )
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      isCancellingLineItem: false,
      cancelledLineItemIndices: [],
      currentOfferFromOrder: null,
      liveOffers: [],
      selectedOffers: [],
      expandedRowIndex: [],
      liftingPeriodFormValid: false,
      formValid: false,
      viewManageOrderNumbersDialog: false,
      viewEditDeleteConfirmationDialog: false,
      viewEditOrderDialogVisible: true,
      isCancelingOrder: false,
      ordersOriginal: [],
      ordersEditable: [],
      orderBasket: null,
      orderMarketWindow: null,
      tempIdCount: 0,
      deliveryLocations: [],
      orderUpdates: {},
      deliveryDateOptions: {
        disabledDate(time) {
          return time.getTime() < moment().startOf("day");
        },
      },
      liftingPeriodRules: {
        liftingPeriod: [{ required: true, validator: validateLiftingPeriod, trigger: ["change", "blur"] }],
      },
      formRules: {
        price: [{ required: true, validator: validateNumberInput, trigger: ["change", "blur"] }],
        quantity: [{ required: true, validator: validateOfferInput, trigger: ["change", "blur"] }],
        releaseNumber: [{ required: true, validator: validateReleaseNumberInput, trigger: ["change", "blur"] }],
      },
      pickerStartOptions: {
        disabledDate: this.disabledStartDates,
      },
      editOrderForm: {
        deliveryDate: null,
        deliveryLocation: {},
        liftingPeriod: [],
        offers: [],
        splitOffers: [],
        reference: "",
      },
    };
  },
  computed: {
    ...mapGetters("inputCheckers", ["numeralPositive", "naturalNumber"]),
    ...mapGetters("itemRemoval", ["showItemRemovalConfirmation", "unsavedChangesRemovalConfirmed"]),
    ...mapGetters("metadata", ["bioProductConfig", "productConfig", "blendedProductConfig", "staMatrix"]),
    ...mapGetters("login", ["getAccountType", "isGenerateOrderNumbersEnabled"]),
    manageOrderNumbersEnabled() {
      return this.$store.getters["login/isUpdateOrderNumbersEnabled"];
    },
    hasChangeOccured() {
      const changeableFields = this.ordersEditable.map((order) => {
        return {
          quantityOrdered: order.quantity,
          price: order.price,
          liftingPeriod: this.isBunkering
            ? null
            : this.editOrderForm.liftingPeriod.map((date) => this.convertStringToDate(date)),
          movementNumber: order.movementNumber,
          reference: this.editOrderForm.reference,
          deliveryLocation: this.editOrderForm.deliveryLocation._id,
          deliveryDate: this.convertStringToDate(this.editOrderForm.deliveryDate),
        };
      });
      const originalFields = this.ordersOriginal.map((order) => {
        return {
          quantityOrdered: order.quantity,
          price: order.price,
          liftingPeriod: this.isBunkering ? null : order.liftingPeriod.map((date) => this.convertStringToDate(date)),
          movementNumber: order.movementNumber,
          reference: order.reference || "",
          deliveryLocation: this.assignLocation(order.delivery_location)._id,
          deliveryDate: this.convertStringToDate(order.ISODeliveryDate),
        };
      });
      return !isEqual(originalFields, changeableFields);
    },
    getOrderMarketWindow() {
      return this.orderMarketWindow;
    },
    currentOrderDetails() {
      return this.ordersEditable;
    },
    currentOrderDetailsFirstItem() {
      return this.currentOrderDetails.length ? this.currentOrderDetails[0] : null;
    },
    isContract() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.offer_type === "Contract";
    },
    isBunkering() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.product_type === "Bunkering";
    },
    isDeliveredIn() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.haulage;
    },
    isPending() {
      return this.currentOrderDetailsFirstItem.status === "INCOMPLETE";
    },
    currentOrderHasBeenEdited() {
      return this.currentOrderDetailsFirstItem.edited;
    },
    currentOrderHasBeenCancelled() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.orderCancelled ? true : false;
    },
    isAtLeastOneSplitItem() {
      return this.currentOrderDetails.some((offer) => offer.isSplit);
    },
    isAtLeastOneCancelledItem() {
      return this.currentOrderDetails.some((offer) => offer.lineItemCancelled);
    },
    isItemSelected() {
      return this.selectedOffers.length > 0;
    },
    canSplitItems() {
      return (
        !this.isBunkering &&
        !this.currentOrderHasBeenCancelled &&
        !this.isCancelingOrder &&
        !this.isConfirmingOrder &&
        !this.isItemSelected
      );
    },
  },
  watch: {
    showItemRemovalConfirmation() {
      if (!this.showItemRemovalConfirmation && !this.viewManageOrderNumbersDialog) {
        this.viewEditOrderDialogVisible = true;
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
    unsavedChangesRemovalConfirmed() {
      if (this.unsavedChangesRemovalConfirmed && !this.viewManageOrderNumbersDialog) {
        this.$emit("update:viewEditOrderDialog", false);
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
  },
  beforeCreate() {},
  async created() {
    const { offers } = await getOffers({ offerIds: this.orders.map(({ offerId }) => offerId) });
    this.liveOffers = offers;
  },
  beforeMount() {},
  async mounted() {
    // we make a deep copy of the orders object to ensure we dont modify the props data
    // will be used later to compare again ordersEditable to see if changes have occured
    this.ordersOriginal = JSON.parse(JSON.stringify(this.orders));
    if (this.isConfirmingOrder && this.manageOrderNumbersEnabled && this.isComingFromOrderCapture) {
      this.openManageOrderNumbersDialog();
    } else if (this.isConfirmingOrder && !this.manageOrderNumbersEnabled && this.isComingFromOrderCapture) {
      this.saveChanges();
    }
    // create a deep copy of the originalOrder object to be modified by user
    this.copyOrdersToEditableObject();
    this.createOrderObject();
    if (this.isDeliveredIn) {
      this.deliveryLocations = await this.getDeliveryLocations(this.currentOrderDetailsFirstItem.buyer._id);
    }
    if (this.currentOrderDetailsFirstItem) {
      this.editOrderForm.liftingPeriod = this.assignLiftingPeriod();
      this.editOrderForm.reference = this.currentOrderDetailsFirstItem.reference || "";
      this.editOrderForm.deliveryLocation = this.assignLocation(this.currentOrderDetailsFirstItem.delivery_location);
      this.editOrderForm.deliveryDate = this.currentOrderDetailsFirstItem.ISODeliveryDate;
      await this.retrieveMarketWindowAndBasketData();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    async reloadOffers() {
      this.$emit("reloadOffers", this.currentOrderDetailsFirstItem);
    },
    structureRefsIntoArray(references) {
      return references ? references.split(";") : [];
    },
    hasMultipleRefs() {
      let references = this.structureRefsIntoArray(this.currentOrderDetailsFirstItem.reference);
      if ((this.isContract || this.isBunkering) && references.length > 1) {
        return true;
      } else {
        return false;
      }
    },
    async generateReleaseNumber() {
      const releaseNumberResponse = await this.axios.get("/api/releaseNumber");
      const {
        data: {
          payload: { releaseNumber = "" },
        },
      } = releaseNumberResponse;
      this.currentOrderDetails.forEach((order, index) => {
        if (this.selectedOffers.includes(index)) {
          order.releaseNumber = releaseNumber;
        }
      });
      this.selectedOffers = [];
    },
    getReferenceLineNumber(index) {
      let references = this.currentOrderDetailsFirstItem.reference.split(";");
      let currentReference = references[index];
      return currentReference ? currentReference.trim() : "-";
    },
    calculateOrderDisplay() {
      return getOrderStatusDisplay(this.currentOrderDetailsFirstItem);
    },
    async getOfferFromOrder(index) {
      const order = this.currentOrderDetails[index];
      if (!this.currentOfferFromOrder || order.offerId !== this.currentOfferFromOrder._id) {
        try {
          let result = await this.$store.dispatch("offers/getOfferById", order.offerId);
          this.currentOfferFromOrder = result.data.offer;
        } catch (ex) {
          this.currentOfferFromOrder = null;
          if (ex.response && ex.response.status === 404) {
            return { notFound: true };
          }
          return null;
        }
      }
      return makeGenericContractFromContractFrequency(this.currentOfferFromOrder);
    },
    onInputCleaveFormatValue(index, type) {
      if (type === "price") {
        this.currentOrderDetails[index].price = event.target._vCleave.getFormattedValue();
      } else {
        this.currentOrderDetails[index].quantity = event.target._vCleave.getFormattedValue();
      }
    },
    toggleExpand(row, index) {
      let currentTable = this.$refs.table;
      currentTable.toggleRowExpansion(row);
      if (this.expandedRowIndex.includes(index)) {
        this.expandedRowIndex = this.expandedRowIndex.filter((x) => x !== index);
      } else {
        this.expandedRowIndex.push(index);
      }
    },
    stringToNumber(value) {
      return formatStringToNumber(value);
    },
    copyOrdersToEditableObject() {
      // we check the original object if it isDelivered in
      if (this.ordersOriginal && this.ordersOriginal[0].haulage) {
        this.ordersOriginal.forEach((order) => {
          const priceWithoutHaulage = this.stringToNumber(order.price) - this.stringToNumber(order.haulage);
          order.price = Number(priceWithoutHaulage.toFixed(2));
        });
      }
      this.ordersEditable = JSON.parse(JSON.stringify(this.ordersOriginal));
    },
    async retrieveMarketWindowAndBasketData() {
      if (this.currentOrderDetailsFirstItem.basket_id) {
        this.orderBasket = await getBasket(this.currentOrderDetailsFirstItem.basket_id);
        this.orderMarketWindow = this.orderBasket.marketWindow;
      }
    },
    assignLiftingPeriod() {
      if (this.currentOrderDetailsFirstItem) {
        if (
          this.currentOrderDetailsFirstItem.liftingPeriod &&
          this.currentOrderDetailsFirstItem.liftingPeriod.length > 1
        ) {
          return [
            this.currentOrderDetailsFirstItem.liftingPeriod[0],
            this.currentOrderDetailsFirstItem.liftingPeriod[1],
          ];
        }
        return this.currentOrderDetailsFirstItem.deliveryDate.split(/\s*-\s*/g).map((item) => {
          return item.trim();
        });
      }
    },
    assignLocation(locationName) {
      if (locationName) {
        return this.deliveryLocations.find((location) => location.name === locationName) || {};
      }
      return {};
    },
    convertStringToDate(stringDate) {
      if (stringDate) {
        return moment(stringDate).format("DD/MM/YYYY");
      }
    },
    closeEditOrderDialog() {
      this.$emit("update:viewEditOrderDialog", false);
      this.$emit("reloadOrders");
    },
    cancelOrder() {
      this.isCancelingOrder = true;
      this.openConfirmationDialog();
    },
    openConfirmationDialog() {
      this.viewEditOrderDialogVisible = false;
      this.viewEditDeleteConfirmationDialog = true;
    },
    showRemovalConfirmation: function (isOpening) {
      if (isOpening) {
        this.viewEditOrderDialogVisible = false;
        // Show removal confirmation modal
        const payload = {
          item: {},
          type: this.$store.getters["itemRemoval/eRemoveItemType"].UnconfirmedChanges,
          showWindow: true,
        };
        this.$store.dispatch("itemRemoval/openConfirmationRemoval", payload);
        setTimeout(() => {
          const removalModal = this.$root.$refs.confirmationRemoveItem.$el;
          $(removalModal).modal({ show: true, keyboard: false });
        }, 250);
      }
    },
    isCostBreakdownDisplayed(orderItem) {
      return this.getAccountType === "seller" && orderItem && orderItem.pricingEngineEnabled;
    },
    async validateForm(formName) {
      return new Promise((res) => {
        this.$refs[formName].validate((valid) => {
          return res(valid);
        });
      });
    },
    openManageOrderNumbersDialog() {
      this.viewEditOrderDialogVisible = false;
      this.viewManageOrderNumbersDialog = true;
    },
    async saveChanges() {
      if (this.isConfirmingOrder && !this.manageOrderNumbersEnabled) {
        this.openConfirmationDialog();
      } else if (this.isConfirmingOrder && this.manageOrderNumbersEnabled) {
        this.openManageOrderNumbersDialog();
      } else {
        let liftingPeriodValid = true;
        if (!this.isBunkering) {
          liftingPeriodValid = await this.validateForm("liftingPeriodForm");
        }
        let formValid = await this.validateForm("form");
        if (formValid && liftingPeriodValid) {
          this.createOrderObject();
          this.openConfirmationDialog();
        }
      }
    },
    disabledStartDates(time) {
      return (
        new Date(this.currentOrderDetailsFirstItem.created).setHours(0, 0, 0, 0) > new Date(time).setHours(0, 0, 0, 0)
      );
    },
    createOrderObject() {
      const offers = this.currentOrderDetails.map((offer, index) => {
        const originalOffer = this.ordersOriginal[index];
        const newOffer = {
          quantityOrdered: offer.quantity,
          price: offer.price,
          collectionTime: -1,
          liftingPeriod: [...this.editOrderForm.liftingPeriod],
          movementNumber: offer.movementNumber,
        };
        // only include changes from the original offer
        const updateOffer = offer.isSplit
          ? { ...newOffer, _id: offer.offerId }
          : Object.keys(newOffer).reduce(
              (changes, key) => {
                if (key === "liftingPeriod") {
                  return newOffer.liftingPeriod.every((value, index) => {
                    return formatDateAsDMY(originalOffer.liftingPeriod[index]) === formatDateAsDMY(value);
                  })
                    ? changes
                    : { ...changes, liftingPeriod: newOffer.liftingPeriod };
                }
                if (key === "quantityOrdered") {
                  return newOffer.quantityOrdered === originalOffer.quantity
                    ? changes
                    : { ...changes, quantityOrdered: newOffer.quantityOrdered };
                }
                return newOffer[key] === originalOffer[key] ? changes : { ...changes, [key]: newOffer[key] };
              },
              { _id: offer.offerId }
            );
        if (originalOffer && originalOffer.price !== offer.price) {
          updateOffer.adjustment =
            originalOffer.adjustment + (this.stringToNumber(offer.price) - this.stringToNumber(originalOffer.price));
        }
        if (offer.isSplit && offer.originalPrice !== offer.price) {
          updateOffer.adjustment =
            offer.adjustment + (this.stringToNumber(offer.price) - this.stringToNumber(offer.originalPrice));
        }
        return updateOffer;
      });
      const splitOffers = this.currentOrderDetails
        .filter((offer) => offer.isSplit)
        .map((offer) => ({
          orderId: offer._id,
          offerId: offer.offerId,
          quantity: offer.quantity,
          releaseNumber: offer.releaseNumber,
          movementNumber: offer.movementNumber,
        }));
      if (this.editOrderForm.reference !== this.currentOrderDetailsFirstItem.reference || "") {
        this.orderUpdates.client_reference = this.editOrderForm.reference;
      }
      if (
        this.editOrderForm.deliveryLocation._id !==
        this.assignLocation(this.currentOrderDetailsFirstItem.delivery_location)._id
      ) {
        this.orderUpdates.location = this.editOrderForm.deliveryLocation;
      }
      if (
        this.convertStringToDate(this.editOrderForm.deliveryDate) !==
        this.convertStringToDate(this.currentOrderDetailsFirstItem.ISODeliveryDate)
      ) {
        this.orderUpdates.deliveryDate = this.editOrderForm.deliveryDate;
      }
      this.orderUpdates.offers = [...offers];
      this.orderUpdates.splitOffers = [...splitOffers];
    },
    tableHeaderClass() {
      return "dark-header-row";
    },
    splitItem(orderItem) {
      const itemCopy = Object.assign({}, orderItem);

      // orderID is created to give a unique ID before saving. A new ID is created when the order is saved.
      const newSplitItem = {
        ...itemCopy,
        orderId: `tempID${this.tempIdCount.toString()}`,
        quantity: "0",
        releaseNumber: undefined,
        movementNumber: undefined,
        isSplit: true,
        originalPrice: itemCopy.price,
      };

      this.tempIdCount++;
      this.currentOrderDetails.push(newSplitItem);
      return;
    },
    unsplitItem(orderItem) {
      const orderIndex = this.currentOrderDetails.findIndex((order) => order.orderId === orderItem.orderId);
      this.currentOrderDetails.splice(orderIndex, 1);
      return;
    },
    removeLineItems() {
      this.isCancellingLineItem = true;
      this.cancelledLineItemIndices = [...this.selectedOffers];
      this.openConfirmationDialog();
    },
    getDeliveryLocations: async function (buyerAccountId) {
      const { data } = await getLocations(buyerAccountId);
      return data.locations;
    },
  },
};
</script>
<style lang="scss">
.el-dialog__footer {
  text-align: center !important;
}

.el-form-item__content {
  margin-left: 0px !important;
}

.el-table--mini td,
.el-table--mini th {
  padding: 1px 0 !important;
}

.customLineHeight {
  .el-col {
    line-height: 2.5;
    color: map-get($platform-theme, tables-text-color);
  }
}

.customFontSize {
  .el-col {
    font-size: 1rem;
  }
}

.el-dialog {
  background-color: #eef0f1 !important;
}
</style>
